import { PlayerInformationCenterWidgetResponse } from "@api-types/platform";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export class PlayerInformationApiService {
	static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/player-information-center`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getPlayerInformationCenterWidget(
		options: ContextOptions
	): Promise<PlayerInformationCenterWidgetResponse> {
		const context = getApiRequestContext(options);
		return await httpClient.post(
			`${this.baseUrl}/widget`,
			null,
			this.getRequestHeaders(context)
		);
	}
}
